// Must be first — initialises Sentry before React mounts.
import "./lib/sentry";

import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { setBaseUrl } from "@workspace/api-client-react";
import App from "./App";
import { applyHostRedirect } from "./lib/host-redirect";
import { API_BASE_URL } from "./lib/utils";
import "./index.css";

// When deployed on its own subdomain (fortifyid.com.au), call the API
// cross-origin at its own subdomain (api.fortifyid.com.au) with credentials.
// Empty in dev / the single path-routed deployment ⇒ relative same-origin /api.
if (API_BASE_URL) {
  setBaseUrl(API_BASE_URL);
}

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: 1 } },
});

// On the staff/client subdomains, bridge to the real base path before mounting
// (single deployment is path-routed). If we redirect, skip rendering entirely.
if (!applyHostRedirect()) {
  createRoot(document.getElementById("root")!).render(
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>,
  );
}
